// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_addMemberToMarketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["MarketingProfileMemberAdded"]);
}

var variablesConverter = {"profilePhotoWithOriginalInput":{"originalPhoto":{"r":"profilePhotoInput"},"croppedPhoto":{"r":"profilePhotoInput"}},"addMemberToMarketingProfileInput":{"socialAccounts":{"r":"marketingProfileSocialAccountsInput"},"profilePhoto":{"r":"profilePhotoWithOriginalInput"},"bio":{"b":""}},"marketingProfileSocialAccountsInput":{},"profilePhotoInput":{},"__root":{"input":{"r":"addMemberToMarketingProfileInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"addMemberToMarketingProfile_MarketingProfileMemberAdded_marketingProfile":{"f":""},"addMemberToMarketingProfile":{"u":"response_addMemberToMarketingProfile"}}};

var wrapResponseConverterMap = {
  response_addMemberToMarketingProfile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"addMemberToMarketingProfile_MarketingProfileMemberAdded_marketingProfile":{"f":""},"addMemberToMarketingProfile":{"u":"response_addMemberToMarketingProfile"}}};

var responseConverterMap = {
  response_addMemberToMarketingProfile: unwrap_response_addMemberToMarketingProfile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "PNG" || $$enum === "JPEG" || $$enum === "GIF" || $$enum === "WEBP") {
    return $$enum;
  }
  
}

function imageContentType_fromString(str) {
  return imageContentType_decode(str);
}

var Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddMemberToMarketingProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addMemberToMarketingProfile",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamMarketingProfileMembersSettings_marketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberAdded",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "AddMemberToMarketingProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addMemberToMarketingProfile",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "TeamMarketingProfileMemberConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamMarketingProfileMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MarketingProfileMember",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfilePhoto",
                                "kind": "LinkedField",
                                "name": "profilePicture",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "ratio",
                                        "variableName": "__relay_internal__pv__DevicePixelRatio"
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "width",
                                        "value": 48
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": "members(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "MarketingProfileMembersList_members",
                    "kind": "LinkedHandle",
                    "name": "members"
                  },
                  {
                    "alias": "membersCount",
                    "args": null,
                    "concreteType": "TeamMarketingProfileMemberConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberAdded",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69564e0c2a54c446bf00ddc6a9ac5f23",
    "id": null,
    "metadata": {},
    "name": "AddMemberToMarketingProfileMutation",
    "operationKind": "mutation",
    "text": "mutation AddMemberToMarketingProfileMutation(\n  $input: AddMemberToMarketingProfileInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  addMemberToMarketingProfile(input: $input) {\n    __typename\n    ... on MarketingProfileMemberAdded {\n      marketingProfile {\n        ...TeamMarketingProfileMembersSettings_marketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MarketingProfileMembersList_member_marketingProfileMember on MarketingProfileMember {\n  displayName\n  profilePicture {\n    url(width: 48, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  title\n  ...MarketingProfileMembersList_member_menu_marketingProfileMember\n}\n\nfragment MarketingProfileMembersList_member_menu_marketingProfileMember on MarketingProfileMember {\n  id\n  displayName\n  publicUrl\n}\n\nfragment MarketingProfileMembersList_teamMarketingProfile on TeamMarketingProfile {\n  members(first: 100) {\n    edges {\n      node {\n        id\n        ...MarketingProfileMembersList_member_marketingProfileMember\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamMarketingProfileMembersSettings_header_marketingProfile on TeamMarketingProfile {\n  membersCount: members {\n    totalCount\n  }\n}\n\nfragment TeamMarketingProfileMembersSettings_marketingProfile on TeamMarketingProfile {\n  ...MarketingProfileMembersList_teamMarketingProfile\n  ...TeamMarketingProfileMembersSettings_header_marketingProfile\n  membersCount: members {\n    totalCount\n  }\n  publicUrl\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var wrap_response_addMemberToMarketingProfile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_addMemberToMarketingProfile = unwrap_response_addMemberToMarketingProfile;
exports.wrap_response_addMemberToMarketingProfile = wrap_response_addMemberToMarketingProfile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
